import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialsService } from 'src/app/Services/materials.service';
import { ProjectService } from 'src/app/Services/project.services'; 
import { Materials } from 'Materials';
import { Project, ProjectMaterial } from 'src/app/objects/Project';
import { MatDialog } from '@angular/material/dialog';

import { SortService } from '../../sort.service';

import { MatTableDataSource } from '@angular/material/table'; 
import { ProjectMaterialService } from 'src/app/Services/projectMaterials';
import { ProjectMaterialAddComponent }from '../project-material-add/project-material-add.component'; 
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

interface MaterialNode {
  name: string;
  children?: MaterialNode[];
  material?: any;
}

@Component({
  selector: 'app-project-material',
  templateUrl: './project-material.component.html',
  styleUrls: ['./project-material.component.css']
})
export class ProjectMaterialComponent implements OnInit {
  projectMaterials: ProjectMaterial[] | any;
  @Input() project: Project | any;
  selectedMaterialsCsv: File | null = null;

  // add these helper properties used by the template / mobile edit
  editedMaterial: any = null;
   
  constructor( private route: ActivatedRoute,private sortService: SortService,
    private router: Router,
    private materialsService: MaterialsService,
    private projectMaterialService: ProjectMaterialService,
    private projectService: ProjectService,private dialog: MatDialog) {  
     }

  // Add this method so the template's (click)="editMaterial(...)" works.
  // It will prefer to call an existing `editRow` method if present (table edit),
  // otherwise fall back to setting the mobile edit state.
  editMaterial(material: any): void {
    const tableEdit = (this as any).editRow;
    if (typeof tableEdit === 'function') {
      tableEdit.call(this, material);
      return;
    }
    this.editedMaterial = material;
    this.editedRow = material;
  }

   

    openProjectMaterialAdd(): void {
      let dialogRef = this.dialog.open(ProjectMaterialAddComponent, {
        height: '90%',
        width: '95%',
        data: { projectId: this.project.id }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        //Load Project
         
        this.loadProject(this.ProjectId);
      });
    }
  

    isDrawerOpened = true; // Set to true to expand the drawer on init
    isMobile= false; 
    



     ProjectId: number | any ;   

     isLoadingResults: boolean | undefined; 
     showAvailbleMaterials: boolean | undefined; 
   
     items: any[] = [];
     materials: Materials []=[];
     // ProjectMaterials: ProjectMaterial []=[];
     sortProperty: string = 'id';
     sortOrder = 1;
     sortListProperty: string = 'id';
     sortListOrder = 1;
     ProjectObject?: Project []=[];
    // ProjectMaterialColumns: string[] = ['productName', 'productCategory',  'subCategory', 'productDescription','productPrice','qty','cost','edit'];
    
    ProjectMaterialColumns: string[] = ['productName', 'total', 'purchasedQty','qty', 'productPrice','purchasedTotal','cost','edit' ];
    //ProjectMaterialColumns: string[] = ['productName','productPrice','qty','cost'];
    //ProjectMaterialColumns: string[] = ['qty' ];
   
    
     sum(val: number, col: string, rowIndex: number) {
       this.project.materials[rowIndex][col] = +val;
       this.project.materials[rowIndex].cost = +this.project.materials[rowIndex].productPrice * +this.project.materials[rowIndex].qty;
     }
    
     purchaseStage!: ['Waiting', 'Partial', 'Complete'];
     dataSource!: MatTableDataSource<ProjectMaterial>;
     editedRow: ProjectMaterial | undefined;

     columnDisplayNames: { [key: string]: string } = {
      productName: 'Product Name',
      total: 'Total',
      purchasedQty: 'Purchased Qty',
      qty: 'Qty',
      productPrice: 'Product Price',
      purchasedTotal: 'Purchased Total',
      cost: 'Cost',
      edit: 'Edit'
    };

  // ngOnInit(): void {
  //   this.checkisMobile();
  //   this.route.paramMap.subscribe((params) => {
  //     this.ProjectId = parseInt(params.get('id') || '0', 10);
  //     if (this.ProjectId > 0) {
  //       this.loadProject(this.ProjectId);
  //     }
  //   }); 
  //   this.loadMaterials(); // ensure this triggers buildMaterialTree when finished
  // }

   

  loadProject(projectId: number) {
  
    this.projectService.getProject(projectId).subscribe((project) => {
      this.project = project;
    
    // Sort materials in descending order by id (most recent first)
    const sortedMaterials = project.materials.sort((a: any, b: any) => {
      return (b.id || 0) - (a.id || 0);
    });
    
    this.projectMaterials = sortedMaterials;

 
    this.dataSource = new MatTableDataSource<ProjectMaterial>(sortedMaterials);
      console.log(this.dataSource)
        console.log(this.project.materials); 
        
    });
 
  }

  
  sortIcon(property: string) {
    if (property === this.sortProperty) {
        return this.sortOrder === 1 ? '☝️' : '👇';
    }
    return '';
}
 


sortListBy(property: string) {
   
  this.sortListOrder = property === this.sortListProperty ? (this.sortListOrder * -1) : 1;
  this.sortListProperty = property;
  this.items = [...this.materials.sort((a: any, b: any) => {
      // sort comparison function
      let result = 0;
      if (a[property] < b[property]) {
          result = -1;
      }
      if (a[property] > b[property]) {
          result = 1;
      }
      return result * this.sortListOrder;
  })];
}

sortListIcon(property: string) {
  if (property === this.sortListProperty) {
      return this.sortListOrder === 1 ? '☝️' : '👇';
  }
  return '';
}
  sortBy(property: string) {
     
    this.sortOrder = property === this.sortProperty ? (this.sortOrder * -1) : 1;
    this.sortProperty = property;
    this.items = [...this.materials.sort((a: any, b: any) => {
        // sort comparison function
        let result = 0;
        if (a[property] < b[property]) {
            result = -1;
        }
        if (a[property] > b[property]) {
            result = 1;
        }
        return result * this.sortOrder;
    })];
}

sortByProjectMaterial(property: string) {
     
  
}
 

editMaterialinProject(material:ProjectMaterial)
{

}
  removeMaterialfromProject(material:ProjectMaterial) 
  {
    
  
    this.projectMaterialService.deleteMaterial(material)
    .subscribe(res => {
       
        
        this.isLoadingResults = true;
        console.log('Project edited successfully!');
       
         
       this.loadProject(this.project?.id);
       
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });  
  }

 

  toggleAvailbleMaterials()
  {
    if(this.showAvailbleMaterials)
    {
      this.showAvailbleMaterials = false;
    }
    else
    {
      this.showAvailbleMaterials = true;
    }

  }
  addMaterialToProjectMaterials(material: Materials): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        if (!this.project) {
          return reject(new Error('Project not loaded'));
        }

        // normalize incoming name for duplicate check
        const incomingName = (material.productName || '').toString().trim().toLowerCase();
        const incomingId = material.id ?? null;

        // take a stable snapshot of current project materials (avoid racing with updates)
        const existingMaterialsSnapshot = [...(this.project.materials || [])];

        // prevent adding duplicates to the same project (check by id if available, otherwise by normalized name)
        const alreadyExists = existingMaterialsSnapshot.some((m: any) => {
          const mName = (m.productName || '').toString().trim().toLowerCase();
          const mId = m.sourceMaterialId ?? m.id ?? null; // support different shapes
          return (incomingId && mId && mId === incomingId) || (incomingName && mName === incomingName);
        });
        if (alreadyExists) {
          return resolve();
        }

        // create fresh material object for project (avoid mutating source arrays)
        const newProjectMaterial: any = {
          productCategory: material.productCategory,
          productDescription: material.productDescription,
          productName: material.productName,
          productPrice: material.productPrice || 0,
          productWeight: material.productWeight,
          subCategory: material.subCategory,
          qty: material.total ?? 1,
          cost: (material.productPrice || 0) * (material.total ?? 1),
          // keep reference to source material id so future checks can use it
          sourceMaterialId: incomingId,
          id: 0
        };

        // clone project and its materials array so we don't mutate while looping
        const newProject: Project = { ...(this.project || {}) } as any;
        newProject.materials = [...(this.project.materials || [])];
        newProject.materials.push(newProjectMaterial);
       // newProject.totalProjectPrice = this.getTotalCost(newProject);

        // wait for server update before resolving so caller's await works correctly
        this.projectService.updateProject(newProject).subscribe({
          next: (res) => {
            // set project to server-accepted state where possible
            this.project = newProject;
            resolve();
          },
          error: (err) => {
            console.error('Failed to add material to project', err);
            reject(err);
          }
        });
      } catch (err) {
        reject(err);
      }
    });
  }

  reLoad(){
    this.router.navigate([this.router.url])
  }

  getTotalCost(newProject: Project)
  {
  
    const sum = newProject.materials.reduce((accumulator, object) => {
      return accumulator + object.cost;
    }, 0);
    return sum;
  }

  getCurrentProjectPrice(newProject: Project)
  {
  
    const sum = newProject.materials.reduce((accumulator, object) => {
      return accumulator + object.purchasedTotal;
    }, 0);
    return sum;
  }


  editRow(element: ProjectMaterial) {
   
    this.editedRow = element; // {element };
  }

  cancelEdit(element: ProjectMaterial) {
    // Restore original values
    this.editedRow = undefined;
  }

  UpdateProjectTotals()
  {
        this.loadProject(this.project?.id);

    let newProject: Project   = Object.assign({}, this.project); 
  
    newProject.currentProjectPrice = +this.getCurrentProjectPrice(this.project);
    newProject.totalProjectPrice = +this.getTotalCost(this.project);
    this.projectService.updateProject(newProject)
    .subscribe(res => {
       
        this.reLoad();
        this.isLoadingResults = false;
        console.log('Project edited successfully!'); 
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });
  }

  
  checkisMobile() { 
     
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
    if(width < 768)
    {this.isMobile = true;
    }
      else
    {this.isMobile = false;}
    
    
  }

  saveEdit(element: ProjectMaterial) {
    // Update data source with edited values
    let materials: ProjectMaterial[]= this.project.materials!;
    let m:ProjectMaterial | any
    // FIX: use comparison (===) instead of assignment (=)
    m = materials.find(a => a.id === element.id);
    if (!m) {
      console.error('Edited material not found', element);
      this.editedRow = undefined;
      return;
    }

    m.productPrice = +element.productPrice;
    m.qty = +element.qty;
    m.cost = +m.productPrice * m.qty;
    element.cost =  m.cost ;

    m.purchasedQty = element.purchasedQty;
    m.purchasedTotal = +m.productPrice * element.purchasedQty;

    m.productName = element.productName;

    this.projectMaterialService.editMaterial(m)
    .subscribe(res => {
        this.isLoadingResults = false;
       // this.UpdateProjectTotals();
        console.log('Project edited successfully!');
       }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });

    this.editedRow = undefined;
  }

      // Called from the file input
  onMaterialsCsvSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    this.selectedMaterialsCsv = input.files && input.files.length ? input.files[0] : null;
  }

  // Upload and process CSV: lookup available materials and associate with project
  async uploadMaterialsCsv() {
    if (!this.selectedMaterialsCsv) { return; }
    const text = await this.readFileAsText(this.selectedMaterialsCsv);
    const rows = this.parseMaterialsCsv(text);
    if (!rows.length) { alert('No rows found in CSV'); return; }

    // dedupe CSV rows by normalized product name or id BEFORE any server operations
    const seen = new Set<string>();
    const uniqueRows: Array<Record<string,string>> = [];
    for (const row of rows) {
      const key = ((row['product name'] || row['name'] || row['id'] || '') + '').toString().trim().toLowerCase();
      if (!key) { continue; }
      if (seen.has(key)) { continue; }
      seen.add(key);
      uniqueRows.push(row);
    }

    if (!confirm(`Add ${uniqueRows.length} unique materials to project?`)) { return; }

    let added = 0;
    let missing = 0;

    for (const row of uniqueRows) {
      const key = (row['product name'] || row['name'] || '').toString().trim().toLowerCase();
      const idKey = (row['id'] || '').toString().trim();

      // try to find by productName or id in available materials
      const match = this.materials.find(m => {
        const mName = (m.productName || '').toString().trim().toLowerCase();
        return (mName && mName === key) || (m.id && idKey && m.id.toString() === idKey);
      });

      if (match) {
        const projectMaterial: any = { ...match };
        if (row['qty']) { projectMaterial.total = Number(row['qty']) || projectMaterial.qty || 1; }
        if (row['productprice'] || row['price']) {
          projectMaterial.productPrice = parseFloat((row['productprice'] || row['price']).toString().replace(/[^0-9.\-]/g, '')) || projectMaterial.productPrice;
        }

        // extra guard: check current project materials snapshot for duplicates before calling add
        const normalizedIncoming = (projectMaterial.productName || '').toString().trim().toLowerCase();
        const alreadyInProject = (this.project.materials || []).some((pm: any) => {
          const pmName = (pm.productName || '').toString().trim().toLowerCase();
          const pmSourceId = pm.sourceMaterialId ?? pm.id ?? null;
          return (match.id && pmSourceId && pmSourceId === match.id) || (normalizedIncoming && pmName === normalizedIncoming);
        });
        if (alreadyInProject) {
          // skip duplicate
          continue;
        }

        try {
          await this.addMaterialToProjectMaterials(projectMaterial);
          added++;
        } catch (err) {
          console.error('Failed to add material', projectMaterial, err);
        }
      } else {
        console.warn('Material not found for CSV row', row);
        missing++;
      }
    }

    alert(`Import complete. Added: ${added}. Not found: ${missing}.`);
    this.selectedMaterialsCsv = null;
    // reload materials and project view
    this.loadMaterials();
    this.loadProject(this.project?.id);
  }

  // helper to read file
  private readFileAsText(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve((reader.result || '') as string);
      reader.onerror = () => reject(reader.error);
      reader.readAsText(file);
    });
  }

  // Basic CSV parser — header => lowercased keys, simple split on commas.
  private parseMaterialsCsv(text: string): Array<Record<string,string>> {
    const lines = text.split(/\r?\n/).map(l => l.trim()).filter(l => l.length);
    if (!lines.length) { return []; }
    const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
    const rows: Array<Record<string,string>> = [];
    for (let i = 1; i < lines.length; i++) {
      const cols = lines[i].split(',').map(c => c.trim());
      if (cols.length === 0) { continue; }
      const obj: Record<string,string> = {};
      for (let j = 0; j < headers.length; j++) {
        obj[headers[j]] = cols[j] ?? '';
      }
      rows.push(obj);
    }
    return rows;
  }

  // Download small sample CSV
  downloadProjectMaterialsSampleCsv() {
    const sample = [
      'Product Name,Qty,Product Price,Id',
      'Brick,100,0.5,',           // productName used to lookup
      'Cement,10,7.25,',          // optionally provide id instead of name
      'Lumber,10,5.75,'
    ].join('\r\n');
    const blob = new Blob([sample], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'project-materials-sample.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  // Tree helpers
  treeControl = new NestedTreeControl<MaterialNode>(node => node.children);
  treeDataSource = new MatTreeNestedDataSource<MaterialNode>();
  hasChild = (_: number, node: MaterialNode) => !!node.children && node.children.length > 0;

  ngOnInit() {
    this.checkisMobile();
    this.route.paramMap.subscribe((params) => {
      this.ProjectId = parseInt(params.get('id') || '0', 10);
      if (this.ProjectId > 0) {
        this.loadProject(this.ProjectId);
      }
    }); 
    //this.loadMaterials(); // ensure this triggers buildMaterialTree when finished
  }

  // call this after materials are set/updated
  private buildMaterialTree() {
    if (!this.projectMaterials || !this.projectMaterials.length) {
      this.treeDataSource.data = [];
      return;
    }

    const catMap = new Map<string, any[]>();
    this.projectMaterials.forEach((m: any) => {
      const cat = (m.productCategory || 'Uncategorized').toString().trim();
      if (!catMap.has(cat)) { catMap.set(cat, []); }
      catMap.get(cat)!.push(m);
    });

    const data: MaterialNode[] = [];
    for (const [cat, items] of catMap.entries()) {
      data.push({
        name: cat,
        children: items.map(it => ({
          name: it.productName || it.name || ('#' + (it.id ?? '')),
          material: it
        }))
      });
    }

    this.treeDataSource.data = data;
    // optional: collapse all initially
    this.treeControl.dataNodes = this.treeDataSource.data;
    this.treeControl.collapseAll();
  }

  // ensure loadMaterials triggers buildMaterialTree:
  private loadMaterials() {
    // If you already have a method named loadMaterials, adapt this to call buildMaterialTree() inside its subscribe
    this.materialsService.GetMaterials().subscribe(list => {
      this.materials = list || [];
      this.buildMaterialTree();
    });
  }
}